// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaVideoLiveStreamOn_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 5.00041 5.49414 7.95915 1 11.0004V5.00041ZM11.7653 15.7911 10.2704 14.4563C11.9538 12.8209 12.9997 10.5328 12.9997 8.00041 12.9997 5.46169 11.9486 3.16847 10.2578 1.53225L11.7637.208008C13.7626 2.19973 14.9997 4.9556 14.9997 8.00041 14.9997 11.0444 13.7633 13.7995 11.7653 15.7911Z" class="svg-bg"/>
  <path d="M10.4997 8.00041C10.4997 9.89344 9.69049 11.5975 8.39907 12.7854L6.89674 11.444C7.87693 10.6185 8.49973 9.38219 8.49973 8.00041C8.49973 6.59979 7.85984 5.34862 6.85646 4.5233L8.37196 3.1906C9.67915 4.37957 10.4997 6.09416 10.4997 8.00041Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 11.7995C0 8.32292 1.47843 5.19164 3.84087 3.00008L5.39241 4.29302C3.31231 6.12551 1.99998 8.80907 1.99998 11.7991 1.99998 14.7892 3.31234 17.4728 5.39249 19.3053L3.84054 20.5986C1.47829 18.4071 0 15.2759 0 11.7995ZM20.1593 20.5987C22.5217 18.4072 24 15.276 24 11.7995 24 8.32286 22.5215 5.19154 20.159 2.99997L18.6074 4.29302C20.6874 6.12551 21.9998 8.80907 21.9998 11.7991 21.9998 14.7892 20.6874 17.4728 18.6073 19.3053L20.1593 20.5987Z" class="svg-bg"/>
  <path d="M3.99953 11.7991C3.99953 9.29487 5.15015 7.0594 6.95154 5.59252L8.52722 6.90558C6.99748 7.99293 5.99951 9.77958 5.99951 11.7993 5.99951 13.819 6.9974 15.6055 8.52703 16.6929L6.95166 18.0057C5.1502 16.5388 3.99953 14.3033 3.99953 11.7991ZM17.0472 18.0057C18.8487 16.5388 19.9994 14.3033 19.9994 11.7991 19.9994 9.29487 18.8488 7.0594 17.0474 5.59252L15.4717 6.90558C17.0014 7.99293 17.9994 9.77958 17.9994 11.7993 17.9994 13.819 17.0015 15.6055 15.4719 16.6929L17.0472 18.0057ZM9.9999 14.9998 14.9998 11.9999 9.9999 8.99991V14.9998Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaVideoLiveStreamOn is a generated icon component.
 */
let IconMediaVideoLiveStreamOn = IconMediaVideoLiveStreamOn_1 = class IconMediaVideoLiveStreamOn extends IconBaseElement {
    render() {
        return html `${IconMediaVideoLiveStreamOn_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaVideoLiveStreamOn.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMediaVideoLiveStreamOn = IconMediaVideoLiveStreamOn_1 = __decorate([
    customElement('zui-icon-media-video-live-stream-on')
], IconMediaVideoLiveStreamOn);
export { IconMediaVideoLiveStreamOn };
